import { render, staticRenderFns } from "./r-trigger-item-group.vue?vue&type=template&id=0853b672&scoped=true"
import script from "./r-trigger-item-group.vue?vue&type=script&lang=js"
export * from "./r-trigger-item-group.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-item-group.vue?vue&type=style&index=0&id=0853b672&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0853b672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0853b672')) {
      api.createRecord('0853b672', component.options)
    } else {
      api.reload('0853b672', component.options)
    }
    module.hot.accept("./r-trigger-item-group.vue?vue&type=template&id=0853b672&scoped=true", function () {
      api.rerender('0853b672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-item-group.vue"
export default component.exports